var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "AddCustomer" },
    [
      _vm.tableVisible
        ? _c(
            "el-dialog",
            {
              attrs: {
                center: true,
                visible: _vm.tableVisible,
                title: _vm.title,
                width: "50%",
              },
              on: {
                close: function ($event) {
                  _vm.tableVisible = false
                },
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "footer",
                    fn: function () {
                      return [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                _vm.tableVisible = false
                              },
                            },
                          },
                          [_vm._v("返回")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", loading: _vm.bntloading },
                            on: { click: _vm.determine },
                          },
                          [_vm._v("确定")]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                911678050
              ),
            },
            [
              _c(
                "div",
                [
                  _c(
                    "el-form",
                    {
                      ref: "ruleForm",
                      attrs: {
                        model: _vm.formData,
                        rules: _vm.rules,
                        "label-width": "80px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "选择销售", prop: "sale_id" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "选择选择销售",
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.formData.sale_id,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "sale_id", $$v)
                                },
                                expression: "formData.sale_id",
                              },
                            },
                            _vm._l(_vm.sale_list, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.fullname, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }